import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-muted px-5 py-20 sm:py-28" data-id="element-18" data-mp="piy2uloqjvk1">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="avcx0k0h7i8f">
        <div className="mx-auto max-w-xl text-center" data-id="element-20" data-mp="aua8ujujftw7">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-secondary" data-id="element-21" data-mp="ftwkwpymr43f">
            Solo per oggi
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.4rem]" data-id="element-22" data-mp="1sty2azt9prg">
            <GiftIcon className="mb-1.5 mr-2 inline-block h-7 w-7 text-primary sm:h-8 sm:w-8" aria-hidden="true" data-id="element-23" data-mp="5tnnx9wtdemz" />
            Ricevi i 5 Bonus Strategici{' '}
            <span className="italic text-primary" data-id="element-24" data-mp="3t183jw6q0m71">«Salva-Docente»</span>
          </h2>
          <p className="mt-3 text-sm text-foreground/60" data-id="element-25" data-mp="1mb9zzc55g2on">
            Valore totale:{' '}
            <span className="font-bold text-foreground/40 line-through" data-id="element-26" data-mp="1r9l5xbsbpt1l">€44,95</span> —
            Inclusi a <span className="font-bold text-primary" data-id="element-27" data-mp="3idmxnu0d71eh">€0</span> nel
            tuo ordine
          </p>
        </div>

        <ol className="mt-12 space-y-6" data-id="element-28" data-mp="3dek5ha5hgpnx">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex flex-col items-center gap-6 rounded-3xl bg-surface p-6 text-center shadow-card sm:flex-row sm:gap-9 sm:p-8 sm:text-left" data-id="element-29" data-mp="3r79ttl8hi6o7" data-mpi={index}>
              <img src={bonus.cover} alt={`Copertina del bonus: ${bonus.title}`} loading="lazy" className="h-64 w-48 shrink-0 rounded-2xl bg-background object-cover sm:h-72 sm:w-56" data-id="element-30" data-mp="2zfkg20a5c6qp" />

              <div className="sm:flex-1" data-id="element-31" data-mp="2uik5pd69khts">
                <div className="flex flex-wrap items-center justify-center gap-3 sm:justify-start" data-id="element-32" data-mp="38gikuksesiac">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary font-display text-sm font-bold text-surface" data-id="element-33" data-mp="33gw6u94ray0h">
                    {index + 1}
                  </span>
                  <span className="rounded-full bg-subtle px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-foreground/70" data-id="element-34" data-mp="irq4gxaxp8ef">
                    Valore {bonus.value}
                  </span>
                  <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-secondary" data-id="element-35" data-mp="3hgy6czjbkypc">
                    Incluso gratis
                  </span>
                </div>

                <h3 className="mt-4 font-display text-xl font-black leading-snug tracking-tight text-foreground sm:text-2xl" data-id="element-36" data-mp="3qixpbxdwacux">
                  {bonus.title}
                </h3>
                <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground/60 sm:mx-0" data-id="element-37" data-mp="2xtqrz1q6ftb9">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}